module.exports = "/virtual-football-league/img/amblems/left/logos/Milan.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Milan.png
// module id = 2113
// module chunks = 4